import React from "react";
import { Link } from "react-router-dom";

import { SectionTitle } from "../typography/typography";
import { Separator } from "../separator/separator";
import { PageIcon } from "../../assets/icons/page_icon";
import { ChevronRightIcon } from "../../assets/icons/chevron_right_icon";
import { reportsListRender } from "../../utils/reports_list_render";
import "./report_grid.scss";

interface ReportGridProps {
    reports: any;
}

export const ReportGrid = (props: ReportGridProps): React.ReactElement => {
    const { reports } = props;

    const fsciReports = reports.filter((report: any) => report.type === "fsci");
    const ffiReports = reports.filter((report: any) => report.type === "ffi");

    const renderReports = (reports: any) => {
        return reportsListRender(
            reports,
            (report: any) => {
                return (
                    <li key={report.id}>
                        <p className="dek">Report Year</p>
                        <p className="year">{report.year}</p>
                        <Link className="report-view" to={`/reports/${report.type}/${report.year}/overview`}>
                            <PageIcon /> View Report
                        </Link>
                        <Link className="report-print" to={`/reports/${report.type}/${report.year}/print`}>
                            <ChevronRightIcon /> Print/Download
                        </Link>
                    </li>
                );
            },
            (report: any) => {
                return (
                    <li className="view-all-reports" key="view-all-reports">
                        <p className="dek">Report Year</p>
                        <p className="year">All-Years View</p>
                        <Link className="report-view" to={`/reports/${report.type}/overview`}>
                            <PageIcon /> View Report
                        </Link>
                        <Link className="report-print" to={`/reports/${report.type}/print`}>
                            <ChevronRightIcon /> Print/Download
                        </Link>
                    </li>
                );
            },
        );
    };

    return (
        <>
            {fsciReports.length > 0 && (
                <div className="page-section">
                    <SectionTitle large>Flourishing School Culture Instrument</SectionTitle>
                    <ul className="reports-grid reports-fsci">{renderReports(fsciReports)}</ul>
                </div>
            )}
            <Separator />
            {ffiReports.length > 0 && (
                <div className="page-section">
                    <SectionTitle large>Flourishing Faith Index</SectionTitle>
                    <ul className="reports-grid reports-ffi">{renderReports(ffiReports)}</ul>
                </div>
            )}
        </>
    );
};
